import React from "react";
import Button from "../common/button/Button";
import { useSelector } from "react-redux";

const ActionButton = ({ to, action, children, className, permissions }) => {
    const { selectedRole } = useSelector((state) => state.auth);

    // Construct the user role string
    const userRole = selectedRole ? `${selectedRole.scope}${selectedRole.role}` : "Customer";

    // Check if the current role is in the permissions array
    const isAuthorized = permissions?.includes(userRole);

    // Only show button if authorized
    if (isAuthorized) {
        return (
            <Button className={className} to={to} onClick={action}>
                {children}
            </Button>
        );
    }

    return null; // No permission, render nothing
};

export default ActionButton;
